/**
 * @url https://stackoverflow.com/questions/16863917/check-if-class-exists-somewhere-in-parent-vanilla-js
 */
export function hasClassInParent(element, classname: string | string[]) {
  const classnames = Array.isArray(classname) ? classname : [classname];

  const cl = element && typeof element.className === "string" ? element.className : "";
  const classes = cl.split(" ");

  if (classes.some((x) => classnames.includes(x))) {
    return true;
  }

  return element.parentNode && hasClassInParent(element.parentNode, classname);
}

export function hasIdInParent(element, id: string) {
  const cId = element?.id;

  if (cId === id) {
    return true;
  }

  return element.parentNode && hasIdInParent(element.parentNode, id);
}
